var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaguesBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    width: 1931.511,
    height: 119.054,
    viewBox: "0 0 1931.511 119.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vagues-bg-blanc",
    transform: "translate(81.917 13.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M1847.361,94.825S1374.065-29.8,634.086,26.205C22.123,72.523-82.713-13.107-82.713-13.107s.072,2.527,0,13.437,2.946,26.209,3.494,45.878L1847.361,105.1V98.855",
    transform: "translate(0.873)",
    fill: "#532c6e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_152",
    "data-name": "Trac\\xE9 152",
    d: "M1849.475,67.333S1369.727-48.054,633.03,25.931-73.411,9.137-73.411,9.137l-2.508,39.849L1849.475,82.595",
    transform: "translate(0 11.154)",
    fill: "#a074c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M1846.96,87.91s-467-120.8-1210.6-59.189S-84.476-7.061-84.476-7.061V100.788H1846.96V97.3",
    transform: "translate(2.635 5.157)",
    fill: "#f7f7f7",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaguesBg);
export default __webpack_public_path__ + "static/media/vagues-bg.f47337d29582459dd0a3366e5b5f0214.svg";
export { ForwardRef as ReactComponent };